// extracted by mini-css-extract-plugin
export default {"Section":"get-support_Section__KnktG","ContactForm":"get-support_ContactForm__CI-AX"};